import React, { useState } from 'react';
import Skills from './Skills';
import Education from './Education';
import Achievements from './Achievements';

const MemberRight = ({ leftinfo }) => {
  const [activeComponent, setActiveComponent] = useState('Skills');

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'Skills':
        return <Skills leftinfo={leftinfo} />;
      case 'Education':
        return <Education leftinfo={leftinfo} />;
      case 'Achievements':
        return <Achievements leftinfo={leftinfo}/>;
      default:
        return null;
    }
  };

  return (
    <div className='mem-right'>
      <div className="info-container">
        {renderActiveComponent()}
      </div>
      <div className="buttons">
        <button
          onClick={() => setActiveComponent('Skills')}
          className={activeComponent === 'Skills' ? 'active' : ''}
        >
          Skills
        </button>
        <button
          onClick={() => setActiveComponent('Education')}
          className={activeComponent === 'Education' ? 'active' : ''}
        >
          Education
        </button>
        <button
          onClick={() => setActiveComponent('Achievements')}
          className={activeComponent === 'Achievements' ? 'active' : ''}
        >
          Achievements
        </button>
      </div>
    </div>
  );
};

export default MemberRight;
